import { render, staticRenderFns } from "./LessonSection.vue?vue&type=template&id=10ec6b58&scoped=true"
import script from "./LessonSection.vue?vue&type=script&lang=js"
export * from "./LessonSection.vue?vue&type=script&lang=js"
import style0 from "./LessonSection.vue?vue&type=style&index=0&id=10ec6b58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ec6b58",
  null
  
)

export default component.exports